<template>
  <div class="footer_container">
    <div class="footer_main">
      <div class="flex">
        <div class="col">
          <div class="title">产品列表</div>
          <div class="ul">
            <div class="li" @click="routerPush('/product/existingEvidence')">
              区块链存证平台
            </div>
            <div class="li" @click="routerPush('/product/signing')">
              区块链签约平台
            </div>
            <div class="li" @click="routerPush('/product/mediate')">
              金融多元化解平台
            </div>
            <div class="li" @click="routerPush('/product/fq')">
              区块链赋强公证平台
            </div>
            <div class="li" @click="routerPush('chain')">
              司法联盟区块链平台
            </div>
          </div>
        </div>

        <div class="col">
          <div class="title">方案列表</div>
          <div class="ul">
            <div class="li" @click="routerPush('/programme/blockchainPlan')">
              区块链存证
            </div>
            <div class="li" @click="routerPush('/programme/fqPlan')">
              金融赋强公证
            </div>
            <div class="li" @click="routerPush('/programme/litigation')">
              诉调赋一体化
            </div>
          </div>
        </div>

        <div class="col">
          <div class="title">了解智签</div>
          <div class="ul">
            <div class="li" @click="routerPush('/corp')">公司简介</div>
            <div class="li" @click="routerPush('/news')">新闻速递</div>
            <!-- <div class="li">新闻速递</div> -->
            <div class="li" @click="routerPush('/partners')">合作伙伴</div>
            <!-- <div class="li">寻求化解帮助</div>
            <div class="li">参与司法帮助</div> -->
          </div>
        </div>
      </div>
      <div class="info">
        <p>
          <img src="~@/assets/image/footer/logo.png" alt="" />
          联系我们，获取更多信息和帮助
        </p>
        <div class="item">
          <div class="label"><i class="el-icon-service"></i> 客服电话：</div>
          <div class="text">17300974710</div>
        </div>
        <div class="item">
          <div class="label"><i class="el-icon-service"></i> 客服座机：</div>
          <div class="text">010-86208512</div>
        </div>
        <div class="item">
          <div class="label"
            ><i class="el-icon-mobile-phone"></i> 商务电话：</div
          >
          <div class="text">0571-87273959</div>
        </div>
        <div class="item">
          <div class="label"><i class="el-icon-message"></i> 电子邮箱：</div>
          <div class="text">bd@xcontract.cn</div>
        </div>
        <img src="~@/assets/image/footer/qrcode.png" alt="" class="qrcode"/>
      </div>
      <div class="filings">
        © 2018-2023 北京智签科技有限公司 版权所有 <br><br>
 京ICP备19008281号-1 | 京网信备 1101082145645103001X号
 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {},

  methods: {
    routerPush(path) {
      if (path === "chain")
        return window.open("https://www.legalxchain.com/cn/home", "_block");

      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang='scss'>
.footer_container {
  width: 100%;
  height: 380px;
  background-color: #37393b;
  color: #ffffff;
  position: relative;
  display: flex;
  justify-content: center;
  .footer_main {
    width: 1200px;
    // height: 100%;
    // background-color: lawngreen;
    height: 308px;
    margin: 0 auto;
    padding: 30px 0;
    display: flex;
    .flex {
      display: flex;
      width: 730px;
      border-right: 1px solid #656565;
    }
    .title {
      font-size: 16px;
      margin-bottom: 24px;
    }
    .ul {
      color: #999999;
      font-size: 14px;
      line-height: 20px;
      .li {
        margin-bottom: 16px;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .col {
      margin-right: 174px;
      &:last-child {
        margin-right: 0;
      }
    }
    .info {
      margin-left: 76px;
      position: relative;
      width: 394px;
      p {
        font-size: 16px;
        display: flex;
        align-items: center;
        margin-bottom: 26px;
        img {
          width: 90px;
          height: 16px;
          margin-right: 14px;
        }
      }
      .qrcode{
        width: 194px;
        height: 194px;
        position: absolute;
        top: 50px;
        right: 45px;
      }
      .item {
        margin-bottom: 10px;
        font-size: 16px;
        .label {
          color: #999999;
          margin-bottom: 7px;
          font-size: 14px;
        }
        img {
          margin-left: 15px;
          width: 80px;
          height: 80px;
        }
      }
    }
    .filings {
      text-align: center;
      width: 780px;
      position: absolute;
      left: 50%;
      bottom: 20px;
      transform: translateX(-50%);
      color: #b4b4b4;
      font-size: 13px;
    }
  }
}
</style>
